const buildDisabilitiesSection = ({ affordablePrograms = [] }) => {
  const hasHUD = affordablePrograms.includes('HUD');
  return {
    name: 'disabilities',
    title: 'DISABILITIES',
    container: 'default',
    titleVariant: 'subsection',
    fields: [
      {
        variant: 'radioGroup',
        name: 'disabilityQuestion',
        label: hasHUD
          ? 'Does your household have any needs that might be better ' +
            'served by a unit which is accessible to persons with mobility, ' +
            'hearing or visual impairments?'
          : 'Do you have a disability?',
        options: [
          { label: 'Yes', value: 'yes' },
          { label: 'No', value: 'no' },
          { label: 'Do not wish to provide', value: 'doNotWishToProvide' },
        ],
        rules: {
          required: true,
        },
        sx: {
          flexDirection: 'row',
        },
      },
    ],
  };
};

export default buildDisabilitiesSection;
